import React from "react";

// MUI
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { StyledTableCell } from "./Table";

//Types
import { Order, HeadCell } from "./Table";

// Styles
const StyledTableSortLabel = styled(TableSortLabel)(() => ({
  "&.MuiTableSortLabel-root": {
    "&:hover": {
      color: "#fff",
    },
    "&.Mui-active": {
      color: "#fff",

      "& .MuiTableSortLabel-icon": {
        color: "#fff",
      },
    },
  },
}));

interface EnhancedTableProps {
  columns: HeadCell[];
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  order: Order;
  orderBy: string;
  isActionsShow?: boolean;
}

const EnhancedTableHead = (props: EnhancedTableProps) => {
  const {
    columns,
    order,
    orderBy,
    onRequestSort,
    isActionsShow = true,
  } = props;
  const createSortHandler =
    (property: string) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {columns.map((headCell) => (
          <StyledTableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            style={{ width: headCell.width || "initial" }}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <StyledTableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </StyledTableSortLabel>
          </StyledTableCell>
        ))}
        {isActionsShow ? (
          <StyledTableCell
            align="center"
            padding="normal"
            style={{ width: "150px" }}
          >
            Actions
          </StyledTableCell>
        ) : null}
      </TableRow>
    </TableHead>
  );
};

export default EnhancedTableHead;
